<template>
  <div>
    <div class="major-banner"></div>

    <v-container
      grid-list-xs
      class="d-flex flex-column justify-center align-center login-section my-5"
    >
      <v-card class="card">
        <v-card-title
          primary-title
          class="dark-blue white--text font-weight-medium px-10 login-title"
          >{{ major.name }}</v-card-title
        >

        <v-container grid-list-xs class="card-body d-flex justify-center">
          <v-form class="form" ref="form" v-on:submit.prevent>
            <div
              class="form-grid"
              v-for="(field, index) in forms"
              :key="field.label"
            >
              <div
                :class="`title numb d-flex align-center justify-end font-weight-regular ${indexCheck(
                  field.label
                )}`"
              >
                {{ index + 1 }}.
              </div>

              <div
                v-if="checkIfHasChild(field.label)"
                class="subtitle-1 d-flex align-center mt-2"
              >
                {{ checkIfRequired(field) }}
              </div>

              <div v-if="checkIfHasChild(field.label)"></div>

              <div
                v-if="
                  checkIfHasChild(field.label) &&
                  field.label !== 'Prestasi yang Pernah Dicapai'
                "
                class="ml-5"
              >
                <div v-for="childField in field.childs" :key="childField.label">
                  <v-text-field
                    autocomplete="off"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    filled
                    v-if="
                      childField.model != 'provinsi_kk' &&
                      childField.model != 'kabupaten_kk' &&
                      childField.model != 'kecamantan_kk' &&
                      childField.model != 'desa_kk' &&
                      childField.model != 'tempat_lahir' &&
                      childField.model != 'no_hp' &&
                      childField.model != 'ibu_no_hp'
                    "
                    class="mt-0 pt-0"
                  ></v-text-field>

                  <v-text-field
                    autocomplete="off"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validatePhone(childField)"
                    filled
                    v-if="
                      childField.model == 'no_hp' ||
                      childField.model == 'ibu_no_hp'
                    "
                    class="mt-0 pt-0"
                  ></v-text-field>

                  <v-text-field
                    filled
                    autocomplete="off"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    v-if="childField.model == 'tempat_lahir' && isTempatLahirLN"
                    class="mt-0 pt-0"
                  ></v-text-field>

                  <v-select
                    filled
                    v-if="
                      childField.model === 'tempat_lahir' && !isTempatLahirLN
                    "
                    :items="allKota"
                    item-text="city_name"
                    item-value="city_name"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    @change="setCities(childField.model)"
                  ></v-select>

                  <v-select
                    filled
                    v-if="childField.model === 'provinsi_kk'"
                    :items="provinsi"
                    item-text="nama"
                    item-value="nama"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    @change="setProvince(childField.model)"
                  ></v-select>

                  <v-select
                    filled
                    v-if="childField.model === 'kabupaten_kk'"
                    :items="kota"
                    :disabled="fields.provinsi_kk.length === 0"
                    item-text="nama"
                    item-value="nama"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    @change="setCities(childField.model)"
                  ></v-select>

                  <v-select
                    filled
                    v-if="childField.label === 'Kecamatan'"
                    :items="kecamatan"
                    :disabled="fields.kabupaten_kk.length === 0"
                    item-text="nama"
                    item-value="nama"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                    @change="setKecamatan()"
                  ></v-select>

                  <v-select
                    filled
                    v-if="childField.label === 'Kelurahan'"
                    :items="kelurahan"
                    :disabled="fields.kecamantan_kk.length === 0"
                    item-text="nama"
                    item-value="nama"
                    :label="checkIfRequired(childField)"
                    v-model="fields[childField.model]"
                    :rules="validateRules(childField)"
                  ></v-select>
                </div>
              </div>

              <v-text-field
                filled
                autocomplete="off"
                v-if="
                  !checkIfHasChild(field.label) &&
                  field.label !== 'Jenis Kelamin' &&
                  field.label !== 'Agama' &&
                  field.label !== 'Tanggal Lahir' &&
                  field.label !== 'SPI (Sumbangan Pendidikan dan Infaq)'
                "
                :label="checkIfRequired(field)"
                v-model="fields[field.model]"
                :rules="validateRules(field)"
              ></v-text-field>

              <v-currency-field
                filled
                autocomplete="off"
                v-if="field.label === 'SPI (Sumbangan Pendidikan dan Infaq)'"
                :label="checkIfRequired(field)"
                type="number"
                v-model="fields[field.model]"
                :disabled="fields.kabupaten_kk.length === 0"
                :rules="checkSpiRules()"
              ></v-currency-field>

              <v-menu
                v-if="field.label === 'Tanggal Lahir'"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    filled
                    autocomplete="off"
                    v-bind="attrs"
                    v-on="on"
                    :label="checkIfRequired(field)"
                    readonly
                    :value="formattedDate"
                    :rules="validateRules(field)"
                  ></v-text-field>
                </template>
                <v-date-picker
                  flat
                  v-model="fields.tanggal_lahir"
                  locale="id-ID"
                  @input="menu = false"
                >
                </v-date-picker>
              </v-menu>

              <v-select
                filled
                v-if="field.label === 'Jenis Kelamin'"
                :items="genders"
                v-model="fields[field.model]"
                :label="checkIfRequired(field)"
                :rules="validateRules(field)"
              ></v-select>

              <v-select
                filled
                v-if="field.label === 'Agama'"
                :items="religions"
                v-model="fields[field.model]"
                :label="checkIfRequired(field)"
                :rules="validateRules(field)"
              ></v-select>
            </div>

            <div class="image-upload">
              <v-container grid-list-xs>
                <center>
                  <b
                    >*Ukuran minimal file adalah 1MB, maksimal 10MB (format:
                    jpeg, jpg, png).</b
                  >
                </center>
                <v-row alignment justify="center">
                  <v-col
                    v-for="(attachment, index) in attachments"
                    :key="attachment.model"
                    xs="8"
                    sm="6"
                    md="4"
                    cols="12"
                    class="ma-5"
                    :class="
                      attachment.model != 'lmp_prestasi' &&
                      attachment.model != 'lmp_gambar_anm'
                        ? ''
                        : 'preview-hidden'
                    "
                  >
                    <div
                      v-if="
                        attachment.model !== 'lmp_gambar_anm' ||
                        (attachment.model === 'lmp_gambar_anm' &&
                          major.name === 'Animasi')
                      "
                      class="d-flex flex-column align-center"
                    >
                      <div
                        class="text-center"
                        v-html="checkIfRequired(attachment)"
                      ></div>

                      <div
                        class="preview d-flex mt-5 justify-center align-center"
                        :data-identification="attachment.model"
                      >
                        <div class="subtitle-1 text-preview">Preview</div>
                        <img
                          v-if="checkImage(attachment.model)"
                          class="preview-image"
                          :src="showImage(attachment.model)"
                          alt="image"
                          :id="attachment.model"
                        />
                      </div>

                      <p
                        class="red--text"
                        style="text-align: center"
                        v-if="checkImageError(attachment.model)"
                      >
                        {{ getImageError(attachment.model) }}
                      </p>

                      <v-btn
                        color="dark-blue white--text"
                        class="my-3 px-10"
                        @click="uploadImage(index, attachment.model)"
                        >Upload</v-btn
                      >

                      <image-uploader
                        :quality="1"
                        :preview="false"
                        outputFormat="file"
                        ref="attachment"
                        doNotResize="['gif', 'svg', 'jpeg', 'jpg', 'png']"
                        accept="image/*"
                        style="display: none"
                        @input="onChangeUploadImage"
                      ></image-uploader>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <div class="subtitle-1 mt-5">Note:</div>
            <div class="subtitle-1">* wajib diisi</div>
            <div class="subtitle-1">
              Pastikan koneksi internet Anda kuat saat mengirim formulir.
            </div>

            <p class="red--text" style="text-align: center">{{ error }}</p>

            <center class="my-5">
              <v-btn
                color="dark-blue white--text mt-5 px-10"
                @click="submitForm"
                >Kirim</v-btn
              >
            </center>
          </v-form>
        </v-container>
      </v-card>

      <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import ImageUploader from "vue-image-upload-resize";
import { EventBus } from "../event-bus.js";
import moment from "moment";

export default {
  components: {
    ImageUploader,
  },
  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    color: "red",
    error: "",
    test_image: "",
    menu: false,
    dalam_kota: -1,
    isTempatLahirLN: false,
    major: {
      name: "",
      color: "",
    },
    spiRulesDalamKotaGrafika: [
      (v) => {
        v = v.replace(/\./g, "");
        return (
          v >= 3000000 ||
          "Nominal SPI harus lebih dari atau sama dengan Rp3.000.000"
        );
      },
    ],
    spiRulesDalamKotaDkv: [
      (v) => {
        v = v.replace(/\./g, "");
        return (
          v >= 4000000 ||
          "Nominal SPI harus lebih dari atau sama dengan Rp4.000.000"
        );
      },
    ],
    spiRulesLuarKota: [
      (v) => {
        v = v.replace(/\./g, "");
        return (
          v >= 12000000 ||
          "Nominal SPI harus lebih dari atau sama dengan Rp12.000.000"
        );
      },
    ],
    spiRulesLuarKotaDg: [
      (v) => {
        v = v.replace(/\./g, "");
        return (
          v >= 6000000 ||
          "Nominal SPI harus lebih dari atau sama dengan Rp6.000.000"
        );
      },
    ],
    forms: [
      // {
      //   label: "Nomor Ujian Nasional SMP/MTs",
      //   model: "sw_no_ujian",
      // },
      {
        label: "Nomor Induk Siswa Nasional (NISN)",
        model: "sw_nisn",
        required: true,
      },
      {
        label: "Nama Siswa (Lengkap)",
        model: "sw_nama_lengkap",
        required: true,
      },
      { label: "Jenis Kelamin", model: "sw_gender", required: true },
      {
        label: "Tempat Lahir",
        required: true,
        childs: [
          { label: "Kabupaten/Kota", model: "tempat_lahir", required: true },
        ],
      },
      { label: "Tanggal Lahir", model: "tanggal_lahir", required: true },
      { label: "Agama", model: "sw_agama", required: true },
      {
        label: "Alamat Siswa Sesuai KK",
        required: true,
        childs: [
          { label: "Provinsi", model: "provinsi_kk", required: true },
          {
            label: "Kabupaten/Kota",
            model: "kabupaten_kk",
            required: true,
          },
          { label: "Kecamatan", model: "kecamantan_kk", required: true },
          { label: "Kelurahan", model: "desa_kk", required: true },
        ],
      },
      {
        label: "Sekolah Asal",
        required: true,
        childs: [
          { label: "Nama", model: "sw_sekolah_asal", required: true },
          { label: "Alamat", model: "sw_sekolah_asal_alamat", required: true },
        ],
      },
      { label: "Tinggi Badan (cm)", model: "sw_tinggi_badan", required: true },
      { label: "Berat Badan (kg)", model: "sw_berat_badan", required: true },
      {
        label: "Nama Orangtua",
        required: true,
        childs: [
          { label: "Ayah", model: "ayah_nama", required: true },
          { label: "Ibu", model: "ibu_nama", required: true },
        ],
      },
      // {
      //   label: "Alamat Orangtua (Lengkap)",
      //   model: "ayah_alamat",
      //   required: true,
      // },
      // {
      //   label: "Pekerjaan Orangtua",
      //   required: true,
      //   childs: [
      //     { label: "Ayah", model: "ayah_pekerjaan", required: true },
      //     { label: "Ibu", model: "ibu_pekerjaan", required: true },
      //   ],
      // },
      {
        label: "Nomor WhatsApp Aktif",
        required: true,
        childs: [
          { label: "Calon Siswa", model: "no_hp", required: true },
          {
            label: "Orang Tua Calon Siswa",
            model: "ibu_no_hp",
            required: true,
          },
        ],
      },
      {
        label: "SPI (Sumbangan Pendidikan dan Infaq)",
        model: "sw_spi",
        required: true,
      },
      // { label: "Nama Wali", model: "wali_nama" },
      // { label: "Alamat Wali (Lengkap)", model: "wali_alamat" },
      // { label: "Pekerjaan Wali", model: "wali_pekerjaan" },
      // { label: "Nomor Telepon Wali", model: "wali_no_hp" },
    ],
    genders: [
      { value: "L", text: "Laki-laki" },
      { value: "P", text: "Perempuan" },
    ],
    religions: [
      { value: "Islam", text: "Islam" },
      { value: "Kristen", text: "Kristen" },
      { value: "Katolik", text: "Katolik" },
      { value: "Hindu", text: "Hindu" },
      { value: "Buddha", text: "Buddha" },
      { value: "Konghucu", text: "Konghucu" },
      { value: "Kepercayaan", text: "Kepercayaan" },
    ],
    attachments: [
      {
        label: "Pas Foto Diri 3x4",
        model: "lmp_foto",
        required: true,
      },
      {
        label: "Catatan Kesehatan dari dokter/puskesmas",
        model: "lmp_kesehatan",
        required: true,
      },
      {
        label: "Akta Kelahiran",
        model: "lmp_akte",
        required: true,
      },
      {
        label: "Kartu Keluarga",
        model: "lmp_kk",
        required: true,
      },
      {
        label: "Surat Keterangan Siswa Aktif atau Foto Rapor Semester Akhir",
        model: "lmp_raport",
        required: true,
      },
      {
        label: "Form Kesanggupan Menaati Tata Tertib",
        model: "lmp_kesanggupan_tata_tertib",
        required: true,
      },
      { label: "Prestasi", model: "lmp_prestasi", required: false },
      { label: "Hasil Karya Gambar", model: "lmp_gambar_anm", required: true },
    ],
    fields: {
      sw_jurusan: "",
      sw_no_ujian: "",
      sw_nisn: "",
      sw_nama_lengkap: "",
      sw_gender: "",
      tempat_lahir: "",
      tanggal_lahir: "",
      sw_agama: "",
      provinsi_kk: "",
      kabupaten_kk: "",
      kecamantan_kk: "",
      desa_kk: "",
      sw_sekolah_asal: "",
      sw_sekolah_asal_alamat: "",
      // bahasa_indonesia: "",
      // matematika: "",
      sw_tinggi_badan: "",
      sw_berat_badan: "",
      ayah_nama: "",
      ibu_nama: "",
      // ayah_alamat: "",
      // ayah_pekerjaan: "",
      // ibu_pekerjaan: "",
      ayah_no_hp: "",
      no_hp: "",
      ibu_no_hp: "",
      sw_spi: "",
      // wali_nama: "",
      // wali_alamat: "",
      // wali_pekerjaan: "",
      // wali_no_hp: "",
    },
    files: {
      lmp_foto: "",
      lmp_kesehatan: "",
      lmp_akte: "",
      lmp_kk: "",
      lmp_raport: "",
      lmp_kesanggupan_tata_tertib: "",
      lmp_prestasi: "",
      lmp_gambar_anm: "",
    },
    urls: {
      url_lmp_foto: "",
      url_lmp_kesehatan: "",
      url_lmp_akte: "",
      url_lmp_kk: "",
      url_lmp_raport: "",
      url_lmp_kesanggupan_tata_tertib: "",
      url_lmp_prestasi: "",
      url_lmp_gambar_anm: "",
    },
    imageErrors: [],
    selectedImageType: "",
    provinsi: [],
    kota: [],
    allKota: [],
    kecamatan: [],
    kelurahan: [],
    json: "",
    progressBar: 0,
  }),
  mounted() {
    this.getJsonFile();
    this.getBirthCity();
    this.getProvinces();
    this.checkMajor();
    // this.setEmptyImage();
    // setTimeout(() => {
    //   this.saveUrlFile();
    // }, 3000);
  },
  computed: {
    formattedDate() {
      return this.fields.tanggal_lahir
        ? moment(this.fields.tanggal_lahir).format("Do MMMM YYYY")
        : "";
    },
  },
  methods: {
    checkSpiRules() {
      // 0 = spi produksi grafika (luar dan dalam kota) dan desain grafika (dalam kota) spiRulesDalamKotaGrafika
      // 1 = spi animasi, rpl, dkv (dalam kota) spiRulesDalamKotaDkv
      // 2 = spi animasi, rpl, dkv (luar kota) spiRulesLuarKota
      // 3 = spi desain grafika (luar kota) spiRulesLuarKotaDg
      switch (this.dalam_kota) {
        case 0:
          return this.spiRulesDalamKotaGrafika;
        case 1:
          return this.spiRulesDalamKotaDkv;
        case 2:
          return this.spiRulesLuarKota;
        case 3:
          return this.spiRulesLuarKotaDg;
      }
    },
    getJsonFile() {
      this.json = require("../static/kota.json");
    },
    setProvince(model) {
      var index = this.provinsi.findIndex((item, i) => {
        return item.nama === this.fields.provinsi_kk;
      });
      if (this.fields.provinsi_kk != "") {
        this.fields.kabupaten_kk = "";
        this.fields.kecamantan_kk = "";
        this.fields.desa_kk = "";
      }
      var provinceId = this.provinsi[index].id;
      this.getCities(provinceId);
    },
    async getProvinces() {
      EventBus.$emit("startLoading");
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      await axios
        .get(
          `https://dev-api-ppdb.smkruskudus.com/data-indonesia/propinsi.json`
        )
        .then((res) => {
          this.provinsi = res.data;
          EventBus.$emit("stopLoading");
        })
        .catch((err) => {
          console.log(err);
          EventBus.$emit("stopLoading");
        });
    },
    async getBirthCity() {
      this.allKota = this.json.rajaongkir.results;
    },
    async getCities(id) {
      EventBus.$emit("startLoading");
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      await axios
        .get(
          `https://dev-api-ppdb.smkruskudus.com/data-indonesia/kabupaten/${id}.json`
        )
        .then((res) => {
          this.kota = res.data;
          EventBus.$emit("stopLoading");
        })
        .catch((err) => {
          console.log(err);
          EventBus.$emit("stopLoading");
        });
    },
    setCities(model) {
      var index = this.kota.findIndex((item, i) => {
        if (model === "kabupaten_kk") {
          return item.nama === this.fields.kabupaten_kk;
        } else {
          return item.nama === this.fields.tempat_lahir;
        }
      });

      // status dalam_kota
      // 0 = spi produksi grafika (luar dan dalam kota) dan desain grafika (dalam kota)
      // 1 = spi animasi, rpl, dkv (dalam kota)
      // 2 = spi animasi, rpl, dkv (luar kota)
      // 3 = spi desain grafika (luar kota)
      if (model === "kabupaten_kk") {
        if (
          this.$route.params.major == "teknik-grafika" ||
          (this.fields.kabupaten_kk == "KAB. KUDUS" &&
            this.$route.params.major == "desain-grafika")
        ) {
          this.dalam_kota = 0;
        } else if (
          this.fields.kabupaten_kk === "KAB. KUDUS" &&
          (this.$route.params.major == "animasi-3d" ||
            this.$route.params.major == "pengembangan-perangkat-lunak-gim" ||
            this.$route.params.major == "animasi-2d")
        ) {
          this.dalam_kota = 1;
          this.fields.sw_spi = "";
        } else {
          this.dalam_kota = 2;
          if (this.$route.params.major == "desain-grafika") {
            this.dalam_kota = 3;
          }
          this.fields.sw_spi = "";
        }

        if (this.fields.kabupaten_kk != "") {
          this.fields.kecamantan_kk = "";
          this.fields.desa_kk = "";
        }
        var cityId = this.kota[index].id;
        this.getKecamatan(cityId);
      } else if (model === "tempat_lahir") {
        if (this.fields.tempat_lahir == "Luar Negeri")
          this.isTempatLahirLN = true;
        else this.isTempatLahirLN = false;
      }
    },
    async getKecamatan(id) {
      EventBus.$emit("startLoading");
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      await axios
        .get(
          `https://dev-api-ppdb.smkruskudus.com/data-indonesia/kecamatan/${id}.json`
        )
        .then((res) => {
          this.kecamatan = res.data;
          EventBus.$emit("stopLoading");
        })
        .catch((err) => {
          console.log(err);
          EventBus.$emit("stopLoading");
        });
    },
    setKecamatan() {
      var index = this.kecamatan.findIndex((item, i) => {
        return item.nama === this.fields.kecamantan_kk;
      });
      if (this.fields.kecamantan_kk != "") {
        this.fields.desa_kk = "";
      }
      var kecamatanId = this.kecamatan[index].id;
      this.getKelurahan(kecamatanId);
    },
    async getKelurahan(id) {
      EventBus.$emit("startLoading");
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      await axios
        .get(
          `https://dev-api-ppdb.smkruskudus.com/data-indonesia/kelurahan/${id}.json`
        )
        .then((res) => {
          this.kelurahan = res.data;
          EventBus.$emit("stopLoading");
        })
        .catch((err) => {
          console.log(err);
          EventBus.$emit("stopLoading");
        });
    },
    checkMajor() {
      if (this.$route.params.major == "teknik-grafika") {
        this.major.name = "DKV Konsentrasi Teknik Grafika";
        this.major.color = "#8BF6D8";
        this.fields.sw_jurusan = "DKV Konsentrasi Teknik Grafika";
      } else if (this.$route.params.major == "desain-grafika") {
        this.major.name = "DKV Konsentrasi Desain Grafika";
        this.major.color = "#90CCF4";
        this.fields.sw_jurusan = "DKV Konsentrasi Desain Grafika";
      } else if (this.$route.params.major == "animasi-3d") {
        this.major.name = "Animasi 3D";
        this.major.color = "#F78888";
        this.fields.sw_jurusan = "Animasi Konsentrasi 3D";
      } else if (this.$route.params.major == "animasi-2d") {
        this.major.name = "Animasi 2D";
        this.major.color = "#ECECEC";
        this.fields.sw_jurusan = "Animasi Konsentrasi 2D";
        // close jurusan
        // this.$router.push({ name: "home" });
      } else if (
        this.$route.params.major == "pengembangan-perangkat-lunak-gim"
      ) {
        this.major.name = "Pengembangan Perangkat Lunak dan Gim";
        this.major.color = "#F3D250";
        this.fields.sw_jurusan = "Pengembangan Perangkat Lunak dan Gim";
      }
    },

    checkIfHasChild(label) {
      if (
        label === "Alamat Siswa Sesuai KK" ||
        label === "Sekolah Asal" ||
        label ===
          "Surat Keterangan Siswa Aktif atau Foto Rapor Semester Akhir" ||
        label === "Nama Orangtua" ||
        // label === "Pekerjaan Orangtua" ||
        label === "Nomor WhatsApp Aktif" ||
        label === "Tempat Lahir"
      )
        return true;
      else return false;
    },

    indexCheck(label) {
      if (this.checkIfHasChild(label)) return "mt-2";
    },

    checkIfRequired(field) {
      var name = field.label;
      if (field.required) name = `${name} *`;
      if (name.includes("Pas Foto") || name.includes("Form Kesanggupan"))
        name = `${name}<br><br>`;
      return name;
    },

    // getDataUrl(img) {
    //   const canvas = document.createElement("canvas");
    //   const ctx = canvas.getContext("2d");
    //   img = document.querySelector("#lmp_raport");
    //   // Set width and height
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   // Draw the image
    //   ctx.drawImage(img, 0, 0);
    //   return canvas.toDataURL();
    // },

    // setEmptyImage() {
    //   const img = document.querySelector("#lmp_raport");
    //   img.addEventListener("load", (event) => {
    //     const dataUrl = this.getDataUrl(event.currentTarget);
    //     this.test_image = dataUrl;
    //   });
    // },

    saveUrlFile() {
      var dataUrl = this.test_image;
      const fileBlob = this.dataURItoBlob(dataUrl, "image/png");
      const file = new File([fileBlob], "dummy.png", { type: "image/png" });

      this.urls.url_lmp_raport = URL.createObjectURL(file);
      this.files.lmp_raport = file;

      // this.urls.url_lmp_kesehatan = URL.createObjectURL(file);
      // this.files.lmp_kesehatan = file;

      this.urls.url_lmp_prestasi = URL.createObjectURL(file);
      this.files.lmp_prestasi = file;

      // this.urls.url_lmp_gambar_anm = URL.createObjectURL(file);
      // this.files.lmp_gambar_anm = file;
    },

    uploadImage(index, type) {
      this.selectedImageType = type;
      this.$refs.attachment[index].$el.children[1].click();
    },

    onChangeUploadImage(e) {
      const file = e;
      const type = this.selectedImageType;

      if (file.size < 1024 * 1024) {
        this.text = "Ukuran minimal file adalah 1MB!";
        this.snackbar = true;
        return;
      }

      if (file.size > 1e7) {
        this.text = "File tidak boleh lebih dari 10MB!";
        this.snackbar = true;
        return;
      }

      if (type === "lmp_foto") {
        this.urls.url_lmp_foto = URL.createObjectURL(file);
        this.files.lmp_foto = file;
      } else if (type === "lmp_akte") {
        this.urls.url_lmp_akte = URL.createObjectURL(file);
        this.files.lmp_akte = file;
      } else if (type === "lmp_kk") {
        this.urls.url_lmp_kk = URL.createObjectURL(file);
        this.files.lmp_kk = file;
      } else if (type === "lmp_kesehatan") {
        this.urls.url_lmp_kesehatan = URL.createObjectURL(file);
        this.files.lmp_kesehatan = file;
      } else if (type === "lmp_raport") {
        this.urls.url_lmp_raport = URL.createObjectURL(file);
        this.files.lmp_raport = file;
      } else if (type === "lmp_kesanggupan_tata_tertib") {
        this.urls.url_lmp_kesanggupan_tata_tertib = URL.createObjectURL(file);
        this.files.lmp_kesanggupan_tata_tertib = file;
      }
      // else if (type === "lmp_prestasi") {
      //   this.urls.url_lmp_prestasi = URL.createObjectURL(file);
      //   this.files.lmp_prestasi = file;
      // } else if (type === "lmp_gambar_anm") {
      //   this.urls.url_lmp_gambar_anm = URL.createObjectURL(file);
      //   this.files.lmp_gambar_anm = file;
      // }

      document.querySelector(
        `.preview[data-identification='${type}'] .text-preview`
      ).style.display = "none";
      document.querySelector(
        `.preview[data-identification='${type}']`
      ).style.minHeight = 0;
    },

    dataURItoBlob(dataURI, contentType) {
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // var mimeString = dataURI
      //   .split(',')[0]
      //   .split(':')[1]
      //   .split(';')[0];

      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      var bb = new Blob([ab], { type: contentType });
      return bb;
    },

    checkImage(model) {
      for (var url in this.urls) {
        if (url === `url_${model}` && this.urls[url] !== "") return true;
      }
    },

    showImage(model) {
      for (var url in this.urls) {
        if (url === `url_${model}`) return this.urls[url];
      }
    },

    validateRules(field) {
      if (field.required) {
        return [(v) => !!v || `Field ${field.label} harus diisi`];
      }
    },

    validatePhone(field) {
      var str = this.fields[field.model];
      str = str.substr(0, 2);
      // console.log(`str for ${str} ${field.model}`);
      if (field.required) {
        return [
          (v) => !!v || `Field ${field.label} harus diisi`,
          (v) => str == "08" || "Nomor WhatsApp harus diawali dengan 08",
          (v) =>
            /^[0-9]+$/.test(v) ||
            "Nomor WhatsApp harus berupa angka dan tanpa spasi",
        ];
      }
    },

    validateImage() {
      this.imageErrors = [];

      for (let image in this.files) {
        if (this.files[image]) {
          let fileName = this.files[image].name;
          let extension = fileName.split(".").pop();

          const standartExtensions = ["png", "jpg", "jpeg"];
          const isRight = standartExtensions.filter(
            (ex) => ex === extension.toLowerCase()
          );

          if (isRight.length <= 0) {
            this.imageErrors.push({
              model: image,
              error: "Format file harus berupa .png / .jpg / .jpeg",
            });
          }
        } else if (
          !this.files[image] &&
          // image !== "lmp_raport" &&
          image !== "lmp_prestasi" &&
          image !== "lmp_gambar_anm"
        ) {
          this.imageErrors.push({
            model: image,
            error: "File wajib diisi",
          });
        }
      }
    },

    checkImageError(model) {
      let isError = this.imageErrors.filter((err) => err.model === model);

      if (isError.length > 0) return true;
      else return false;
    },

    getImageError(model) {
      const error = this.imageErrors.filter((err) => err.model === model);
      if (error.length <= 0) return;
      return error[0].error;
    },

    formData() {
      const data = {
        ...this.fields,
        ibu_alamat: this.fields.ayah_alamat,
        sw_alamat: `${this.fields.provinsi_kk} ${this.fields.kabupaten_kk} ${this.fields.kecamantan_kk} ${this.fields.desa_kk}`,
        username: localStorage.getItem("username"),
      };

      const formData = new FormData();
      formData.append("lmp_foto", this.files.lmp_foto);
      formData.append("lmp_kesehatan", this.files.lmp_kesehatan);
      formData.append("lmp_akte", this.files.lmp_akte);
      formData.append("lmp_kk", this.files.lmp_kk);
      formData.append("lmp_raport", this.files.lmp_raport);
      formData.append(
        "lmp_kesanggupan_tata_tertib",
        this.files.lmp_kesanggupan_tata_tertib
      );
      formData.append("lmp_prestasi", this.files.lmp_prestasi);
      formData.append("lmp_gambar_anm", this.files.lmp_gambar_anm);

      for (var field in data) {
        if (field === "tanggal_lahir") {
          var formattedDate = moment(data[field]).format("Do MMMM YYYY");
          formData.append(field, formattedDate);
        } else if (field === "sw_spi") {
          var amount = data[field].toString();
          var sw_spi = amount.replace(/\./g, "");
          formData.append(field, sw_spi);
        } else formData.append(field, data[field]);
      }
      return formData;
    },

    async submitForm() {
      try {
        this.validateImage();
        if (this.imageErrors.length > 0) return;

        const formData = this.formData();

        if (this.$refs.form.validate()) {
          EventBus.$emit("startLoading");
          axios.defaults.headers.post["Content-Type"] =
            "application/x-www-form-urlencoded";

          const config = {
            onUploadProgress: (progressEvent) => {
              let percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              EventBus.$emit("setPercentage", percentCompleted);
            },
          };

          var res = await axios.post(`${this.$api}/daftar`, formData, config);
          // console.log("completed");
          if (
            res.data.STATUS === "SUCCESS" &&
            res.data.MESSAGE === "Berhasil mendaftar"
          ) {
            localStorage.setItem("hasRegister", true);
            EventBus.$emit("stopLoading");

            this.$router.push({ name: "home" });
          } else if (res.data.STATUS == "ERROR") {
            EventBus.$emit("stopLoading");
            this.error = res.data.MESSAGE;
          }
        } else {
          let errorMessage = document.querySelector(".v-text-field__details");

          const distanceToTop = (el) =>
            Math.floor(el.getBoundingClientRect().top);

          EventBus.$emit("stopLoading");

          window.scrollBy({
            top: distanceToTop(errorMessage),
            left: 0,
            behavior: "smooth",
          });
        }
      } catch (e) {
        EventBus.$emit("showSnackbar", e, "red");
        EventBus.$emit("stopLoading");
      }
    },
  },
};
</script>

<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.preview-hidden {
  display: none;
}

.v-menu__content {
  box-shadow: none !important;
}

.v-menu--inline {
  display: none;
}

.login-section {
  min-height: 80vh;
}

.card {
  width: 70%;
}

.login-title {
  font-family: "Montserrat", sans-serif !important;
}

.card-body {
  padding: 30px;
}

.form {
  width: 95%;
}

.form-grid {
  display: grid;
  grid-template-columns: 20px auto;
  grid-gap: 15px;
}

.icon-img {
  width: 20px;
}

.numb {
  font-family: "Montserrat", sans-serif !important;
}

.preview {
  border: 1px solid #374785;
  min-height: 200px;
  max-height: 300px;
  overflow: hidden;
  width: 100%;
}

.preview-image {
  width: 100%;
  height: auto;
}

@media screen and (max-width: 1263px) {
  .card {
    width: 90%;
  }
}

@media screen and (max-width: 450px) {
  .form {
    width: 100%;
    margin: 0 auto;
  }
}
</style>